export default function Grid() {
    return {
        MuiGrid: {
            styleOverrides: {},
        },
    };
}
//# sourceMappingURL=Grid.js.map